import createReactComponent from '../createReactComponent';
export default createReactComponent('percentage', 'IconPercentage', [
  ['path', { d: 'M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-0' }],
  ['path', { d: 'M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-1' }],
  ['path', { d: 'M6 18l12 -12', key: 'svg-2' }],
]);
